import React from 'react'
import { Field } from 'redux-form'
import SVRMAirportOrg from '../../views/SVRMAirportOrg'
import 'antd/dist/antd.css'
import {SVMCONomemEp} from  './index'
const _ = require('lodash')



export class SVMCOTaEp extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.svotaCurryCom = this.svotaCurryCom.bind(me)
        this.state = {
            filters: {

                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
                // "endDate": "2024-07-22T25:42:55.795+00:00" ,
                startDate: new Date()
            }
        }


    }

    svotaCurryCom = (param1, ctxThis) => (o) => {
        console.log("*******svj22****org curry** START")
        console.log(param1)

        let {escountryOrgMCityOb, member, index} = this.props
        console.log('sv*****Sep2******svmotaEp**8TA Array')
        console.log(index)
        console.log(member)
        console.log(escountryOrgMCityOb)
        let escountryOrgMCity = 'US'
        let myorg = `ORG${index}`
        let myval = 'US'
        if(escountryOrgMCityOb && escountryOrgMCityOb[myorg]){
            myval = escountryOrgMCityOb[myorg]
        }
        if(myval && (myval.length == 2) ){
            escountryOrgMCity = myval

        }
        console.log(ctxThis)
        let cidx  = `{param1}2`
        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******avaug30****reduxonChange, value from RFI**")
        //we donoe need value in begining
        //cb onChange will be called by handleTaDest
        console.log(value)
        console.log("*******avaug30****reduxonChange, value from RFI END**")
        let svfly_esquery_data={
            airlines:[
                {
                    "name" : "Alaska Airlines",
                    "IATA" : "AS"
                },
                {
                    "name" : "Atlantic Southeast Airlines",
                    "IATA" : "EV"
                },
                
            ]
            ,
            amap:{
                "B6":{
                    "name" : "JetBlue Airways",
                    "IATA" : "B6"
                },
                "UA":{
                    "name" : "United Airlines",
                    "IATA" : "UA"
                }
            },
            pmap:{
                "DCA":{
                    "airportid": 3520,
                    "altitude": 15,
                    "city": "Washington",
                    "country": "United States",
                    "datsource": "OurAirports",
                    "name": "Ronald Reagan Washington National Airport",
                    "stationType": null,
                    "svdst": "A",
                    "svtimezone": "-5",
                    "svtzDatabaseTimezone": "America/New_York",
                    "IATA": "DCA",
                    "ICAO": "KDCA",
                    "LAT": 38.8521,
                    "LNG": -77.037697
                }
            },
            esqueryDestMob :{
                "type": "location",
                "subType": "AIRPORT",
                "name": "JOHN F KENNEDY INTL",
                "detailedName": "NEW YORK/NY/US:JOHN F KENNEDY",
                "id": "AJFK",
                
                "timeZoneOffset": "-04:00",
                "iataCode": "JFK",
                "geoCode": {
                  "latitude": 40.63973,
                  "longitude": -73.77861
                },
                "address": {
                  "cityName": "NEW YORK",
                  "cityCode": "NYC",
                  "countryName": "UNITED STATES OF AMERICA",
                  "countryCode": "US",
                  "stateCode": "NY",
                  "regionCode": "NAMER"
                },
                "analytics": {
                  "travelers": {
                    "score": 35
                  }
                }
              },
               esqueryMob :{
                   iataCode: "ORD",
                   address:  { cityName: "CHICAGO", cityCode: "CHI", countryName: "UNITED STATES OF AMERICA" },
                   detailedName: "CHICAGO/IL/US:O HARE INTERNATI",
                   geoCode:  { latitude: 41.97862, longitude: -87.90472 },
    
                },
            escountryOrg:"US",
            escountryDst:"US",
            my_orgqueryText: "xx",
            my_dstqueryText: "yy",
            STARTDATE:"2025-11-25",
            ENDDATE: "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
    
    
            esqueryChilds:"m0",
            esqueryInfants:"i0",
            esqueryAdults:"t1",
            esqueryCabin:"ECONOMY",
            esqueryTripType:"roundtrip",
            svpageSize:5
    
    
        }
        let vob = value
        let mofval = null,mofval_str  =''
         
        if (value != null) {
            mofval = value
           
            if(_.isString(mofval) ){
                mofval_str = mofval
            }else{
                mofval_str = ''
                console.log('RFI not sending string type')
            }
           


            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)



            let mom_value = !value ? mofval_str : mofval
        } else {
            mofval = ''
            mofval_str = ''
        }

        let TIME_NO = false


        /*   <SVRAirportDest svfly_esquery_data={svfly_esquery_data} onSearchDesttxtFancy={this.onSearchDesttxtFancy}/>  */
        return (<SVRMAirportOrg escountryOrgMCity={escountryOrgMCity} svoindex={cidx} svfly_esquery_data={svfly_esquery_data}   onSearchDesttxtFancy={onChange}  />)


    }
    renderWithCountry() {
        console.log('render SVMCOTaEp date add')

        let me = this
        let { member,index, countryTwoTypes } = this.props
        if(! countryTwoTypes){
            countryTwoTypes = [
                {
                    "name": "United STates America",
                    "a2": "US",
                    "a3": "USA",
                    "value": "USA",
                    "isonum": "840"
                },
                {
                    "name": "Canada",
                    "isdcode": "01",
                    "a2": "CA",
                    "a3": "CAN",
                    "value": "CAN",
                    "isonum": "124"
                }
            ]
        }
        let param1 = "ORD"
        console.log('spe2******countryTwoTypes')
        console.log(countryTwoTypes)
        let countryTypes = countryTwoTypes
        //let index = ${member}


        return (
        <div>
            <Field 
            
            name={`${member}.my_orgqueryText`}
            type="text"
                className="form-control"
                component={this.svotaCurryCom(param1, this)}
            />
            <div className="c-box-mcitybar" style={{display:"none"}}>
                 <span className="c-span" >
                    <SVMCONomemEp svoindex={index} countryTwoTypes={countryTypes}   placeholder="ES" /> 
                 </span>
            </div>
        </div>
           
        )


    }

    render() {
        console.log('render SVMCOTaEp date add')

        let me = this
        let { member,index, countryTwoTypes,escountryOrgMCityOb } = this.props
        if(! countryTwoTypes){
            countryTwoTypes = [
                {
                    "name": "United STates America",
                    "a2": "US",
                    "a3": "USA",
                    "value": "USA",
                    "isonum": "840"
                },
                {
                    "name": "Canada",
                    "isdcode": "01",
                    "a2": "CA",
                    "a3": "CAN",
                    "value": "CAN",
                    "isonum": "124"
                }
            ]
        }
        let param1 = "ORD"
        console.log('spe2******countryTwoTypes')
        console.log(countryTwoTypes)
        let countryTypes = countryTwoTypes

        console.log('*******SEP2******escountryOrgMCity change', escountryOrgMCityOb)
        
        //let index = ${member}


        return (
       
            <Field 
            
            name={`${member}.my_orgqueryText`}
            type="text"
                className="form-control"
                component={this.svotaCurryCom(param1, this)}
            />
            
      
           
        )


    }

}